export const affiliateListHeaders = [{
  text: 'Firma',
  value: 'firm',
},
{
  text: 'Vorname',
  value: 'firstname',
},
{
  text: 'Nachname',
  value: 'surname',
},
{
  text: 'PLZ',
  value: 'zip',
},
{
  text: 'Ort',
  value: 'location',
},
{
  text: 'Straße',
  value: 'street',
},
{
  text: 'E-Mail',
  value: 'email',
},
{
  text: 'Telefon',
  value: 'phone',
},
{
  text: 'Land',
  value: 'country',
},
{
  text: 'Bundesland',
  value: 'state',
},
{
  text: 'Aktionen',
  value: '',
  sortable: false,
},
];
